import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiGateway } from "api/api-gateway";

@Injectable()
export class ScheduleSummaryService {
    constructor(private apiGateway: ApiGateway) {}

    getUnityList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/unidades")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getInsuranceList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("insurance/app/list")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getPerformerList(): Promise<any> {        
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(`professional/app/list`)
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getProfessionalList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/profissionais")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getProcedureList(insuranceId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/cobertura/" + insuranceId)
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getSpecialityList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get("datasnap/rest/TEntityController/especialidades")
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    getScheduleList(patientId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    "datasnap/rest/TCalendarController/consultaAgendamentoPaciente/" +
                        patientId
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    consultaAgendamentoPorUnidadeEspecialidade(idUnidade, idEspecialidade) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    `datasnap/rest/TCalendarController/consultaAgendamentoUnidadeEspecialidade/${idUnidade}/${idEspecialidade}`
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    saveSchedule(schedule) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .post(
                    `datasnap/rest/TCalendarController/agendamento/`,
                    schedule
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    } 
}
